var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('span',[_vm._v("CopyRight©"+_vm._s(_vm.name)+" All Rights Reserved")]),_vm._v(" "),_c('a',{attrs:{"target":"_blank","href":"https://beian.miit.gov.cn/#/Integrated/index"}},[_vm._v("京ICP备"+_vm._s(_vm.icp))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5848a645","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Footer.vue
// module id = null
// module chunks = 